import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createBlock(_component_Multiselect, {
    class: _normalizeClass([{'multiselect-sm': _ctx.small}, ""]),
    modelValue: _ctx.vModel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vModel) = $event)),
    disabled: _ctx.disabled,
    options: _ctx.referrals,
    "custom-label": (opt) => `${opt.name} (${opt.email})`,
    "track-by": "id",
    "select-label": "Select",
    placeholder: _ctx.multiple ? _ctx.helper.trans('labels.referrals') : _ctx.helper.trans('labels.referral'),
    "open-direction": "bottom",
    multiple: _ctx.multiple,
    searchable: true,
    loading: _ctx.isLoading,
    "internal-search": false,
    "clear-on-select": !_ctx.multiple,
    "close-on-select": !_ctx.multiple,
    "options-limit": 100,
    limit: 1000,
    "show-no-results": false,
    "hide-selected": _ctx.multiple,
    onSearchChange: _ctx.asyncFindReferrals
  }, null, 8, ["class", "modelValue", "disabled", "options", "custom-label", "placeholder", "multiple", "loading", "clear-on-select", "close-on-select", "hide-selected", "onSearchChange"]))
}